import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  WithdrawalCard,
  WithdrawalContainer,
  WithdrawalTopCard,
  WithdrawalTopCardButton,
} from "./Withdrawal.styled";
import { useDispatch, useSelector } from "react-redux";
import { getUserBalance } from "../../feature/wallet/WalletActions";
import { MIN_AMOUNT } from "../../constants";
import Withdraw from "../Withdraw/Withdraw";

const Withdrawal = () => {
  const navigate = useNavigate();
  const { balance } = useSelector((state) => state.wallet);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    Object.keys(user).length && dispatch(getUserBalance({ user: user }));
  }, [dispatch, user]);



  return (
    <WithdrawalContainer>
      <WithdrawalTopCard>
        <WithdrawalTopCardButton
          onClick={() => navigate("/withdrawal-history")}
        >
          Withdrawal History
        </WithdrawalTopCardButton>
        <WithdrawalTopCardButton
          onClick={() => navigate("/set-withdrawal-pin")}
        >
          Set Withdrawal Pin
        </WithdrawalTopCardButton>
      </WithdrawalTopCard>
      <WithdrawalCard>
        <div style={{ marginBlockEnd: "20px" }}>My Balance (TRX)</div>
        <h2 style={{ fontWeight: "bolder" }}>{balance}</h2>
        <h4>
          <span style={{ fontWeight: "bolder" }}>
            The minimum withdrawal is {MIN_AMOUNT} TRX.{" "}
          </span>
        </h4>
      </WithdrawalCard>
      <WithdrawalCard><Withdraw /></WithdrawalCard>
    </WithdrawalContainer>
  );
};

export default Withdrawal;
